import { useMatchingVehiclesContext } from '~/context/new-cars/MatchingVehiclesContext';
import useClosestVehicle from '~/hooks/new-cars/selectors/useClosestVehicle';
import { List } from './MatchingVehiclesView.styles';
import MatchingVehicleCard from '../MatchingVehicleCard';

export default function MatchingVehiclesView() {
  const { vehicles } = useMatchingVehiclesContext();
  const isExactMatch = Boolean(useClosestVehicle());

  return (
    <List
      className={vehicles.length === 1 ? undefined : 'pb-[90px] sm:pb-0'}
      data-testid="matching-vehicles-list"
      isExactMatch={isExactMatch}
    >
      {vehicles.map(vehicle => (
        <MatchingVehicleCard key={vehicle.vehicleId} vehicle={vehicle} />
      ))}
    </List>
  );
}
